/* fm-reccard.js
   Drops the "My Top Recommendation" offer card directly beneath the FIRST
   "Visit Site" button on the elite advertorial family.
   The existing card lower on the page is left alone, so these templates
   carry two CTAs: one at the winner verdict, one at the close.

   Rules it follows:
   - It never touches a GemPages element's style. It only inserts a sibling.
   - Its CTA mirrors whatever href the adjacent Visit Site button carries,
     so link routing stays in one place (the GemPages button).
   - It inserts once. Re-entry is a no-op.
*/
(function () {
  'use strict';

  var IMG = 'https://cdn.shopify.com/s/files/1/0807/0201/3675/files/generated_wNm9hWILhMcDgvVAQVjGjm_5b0724ee-5675-49a8-82a7-7dfdc29cf305.png?width=900';
  var HEADING = 'My Top Recommendation After Months of Testing';
  var BULLETS = ['88 Authentic Books', '9.3 pt Type', '“Yahweh”, not “Lord.”', '365-day money-back guarantee'];
  var CTA = 'GRAB FAITH MADE ETHIOPIAN BIBLE';
  var FALLBACK_HREF = 'https://thefaithmade.com/products/ethiopian-bible';
  var DONE = false;

  function css() {
    if (document.getElementById('fm-rec-css')) return;
    var s = document.createElement('style');
    s.id = 'fm-rec-css';
    s.textContent = [
      '.fm-rec{box-sizing:border-box;margin:28px auto 8px;max-width:980px;width:100%;',
      'font-family:inherit;color:#1b1b1b;-webkit-font-smoothing:antialiased}',
      '.fm-rec *,.fm-rec *::before,.fm-rec *::after{box-sizing:border-box}',
      '.fm-rec .fm-rec__h{margin:0 0 16px !important;font-size:28px !important;line-height:1.3 !important;',
      'font-weight:700 !important;color:#111 !important;text-align:center !important;letter-spacing:normal !important}',
      '.fm-rec__card{display:grid;grid-template-columns:minmax(0,0.9fr) minmax(0,1.1fr);gap:28px;align-items:center;',
      'background:#fff;border:1px solid #e7e2d8;border-radius:16px;padding:24px;',
      'box-shadow:0 1px 2px rgba(17,17,17,.04),0 8px 24px rgba(17,17,17,.06)}',
      '.fm-rec__media{margin:0;min-width:0}',
      '.fm-rec__media img{display:block;width:100%;height:auto;border-radius:10px}',
      '.fm-rec__body{min-width:0}',
      '.fm-rec__list{list-style:none;margin:0 0 20px;padding:0}',
      '.fm-rec__list li{display:flex;align-items:flex-start;gap:12px;margin:0 0 12px;',
      'font-size:19px !important;line-height:1.4 !important;font-weight:600 !important;color:#1b1b1b !important}',
      '.fm-rec__list li:last-child{margin-bottom:0}',
      '.fm-rec__tick{flex:0 0 auto;width:24px;height:24px;margin-top:1px}',
      '.fm-rec__cta{display:flex;align-items:center;justify-content:center;text-align:center;',
      'width:100%;margin:20px 0 0;padding:18px 24px;border-radius:9999px;background:#261A06 !important;color:#fff !important;',
      'font-size:18px !important;line-height:1.25 !important;font-weight:700 !important;letter-spacing:.01em !important;text-decoration:none !important;',
      'transition:background-color .18s ease,transform .18s ease}',
      '.fm-rec .fm-rec__cta:hover,.fm-rec .fm-rec__cta:focus{background:#3b2a0d !important;color:#fff !important;text-decoration:none !important}',
      '.fm-rec__cta:active{transform:translateY(1px)}',
      '.fm-rec__note{margin:14px 0 0;padding:14px 16px;border-radius:10px;background:#faf6ef;',
      'text-align:center !important;font-size:16px !important;line-height:1.45 !important;color:#1b1b1b !important}',
      '.fm-rec .fm-rec__note strong{color:#d12b2b !important;font-weight:700 !important}',
      '.fm-rec .fm-rec__sub{margin:12px 0 0 !important;text-align:center !important;font-size:16px !important;line-height:1.5 !important;color:#3a3a3a !important}',
      '.fm-rec .fm-rec__sub strong{font-weight:700 !important;color:#1b1b1b !important}',
      '@media (max-width:820px){',
      '.fm-rec{margin:22px auto 6px}',
      '.fm-rec .fm-rec__h{font-size:23px !important}',
      '.fm-rec__card{grid-template-columns:1fr;gap:20px;padding:18px;border-radius:14px}',
      '.fm-rec .fm-rec__list li{font-size:17px !important}',
      '.fm-rec .fm-rec__cta{font-size:16px !important;padding:16px 18px}',
      '.fm-rec .fm-rec__note,.fm-rec .fm-rec__sub{font-size:15px !important}}'
    ].join('');
    (document.head || document.documentElement).appendChild(s);
  }

  function tick() {
    return '<svg class="fm-rec__tick" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="12" r="12" fill="#836348"></circle>' +
      '<path d="M6.8 12.3l3.3 3.3 7.1-7.1" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg>';
  }

  function build(href) {
    var wrap = document.createElement('div');
    wrap.className = 'fm-rec';
    wrap.setAttribute('data-fm-rec', '1');
    var items = BULLETS.map(function (b) {
      return '<li>' + tick() + '<span>' + b + '</span></li>';
    }).join('');
    wrap.innerHTML =
      '<h3 class="fm-rec__h">' + HEADING + '</h3>' +
      '<div class="fm-rec__card">' +
        '<figure class="fm-rec__media">' +
          '<img src="' + IMG + '" alt="The Faith Made Complete Ethiopian Bible in English, 88 books, with a 365 day money back guarantee" loading="lazy" decoding="async" width="900" height="900">' +
        '</figure>' +
        '<div class="fm-rec__body">' +
          '<ul class="fm-rec__list">' + items + '</ul>' +
          '<a class="fm-rec__cta" href="' + href + '">' + CTA + '</a>' +
          '<div class="fm-rec__note"><strong>HIGH Risk of Sell-out</strong> - Trusted By Thousands of Christians</div>' +
          '<p class="fm-rec__sub">They offer a <strong>365-Day Moneyback Guarantee,</strong> so you can try risk-free.</p>' +
        '</div>' +
      '</div>';
    return wrap;
  }

  /* The outermost GemPages wrapper for the button, so the card lands after the
     whole button block rather than inside its flex row. */
  function anchorHost(a) {
    var n = a;
    for (var i = 0; i < 6 && n && n.parentElement; i++) {
      n = n.parentElement;
      if (n.tagName === 'GP-BUTTON') return n;
    }
    return a.parentElement || a;
  }

  function firstVisitSite() {
    var all = document.querySelectorAll('a[href]');
    for (var i = 0; i < all.length; i++) {
      var a = all[i];
      var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^visit site$/i.test(t)) return a;
    }
    return null;
  }

  function run() {
    if (DONE) return true;
    if (document.querySelector('[data-fm-rec]')) { DONE = true; return true; }
    var a = firstVisitSite();
    if (!a) return false;
    var host = anchorHost(a);
    if (!host || !host.parentElement) return false;
    css();
    var card = build(a.getAttribute('href') || FALLBACK_HREF);
    host.parentElement.insertBefore(card, host.nextSibling);
    DONE = true;
    return true;
  }

  function start() {
    if (run()) return;
    /* GemPages hydrates late on some templates, so watch briefly then give up. */
    var obs = new MutationObserver(function () { if (run()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
